import React from 'react';

export const Deactivate = () => (
  <svg viewBox="0 0 19 19" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M16.789 9.11597C16.833 7.53512 16.4014 5.97746 15.5499 4.64478C14.6984 3.3121 13.4664 2.26581 12.0134 1.64144C10.5604 1.01707 8.95341 0.843393 7.40057 1.14291C5.84773 1.44243 4.42061 2.20134 3.30407 3.32134C2.18754 4.44133 1.43304 5.87079 1.13833 7.42455C0.843609 8.97831 1.02225 10.5848 1.65111 12.0358C2.27997 13.4869 3.33007 14.7157 4.66538 15.563C6.00068 16.4104 7.55967 16.8372 9.14037 16.7883"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M12.4049 15.0383C12.4049 15.7363 12.6822 16.4058 13.1758 16.8994C13.6694 17.393 14.3389 17.6703 15.0369 17.6703C15.735 17.6703 16.4044 17.393 16.898 16.8994C17.3916 16.4058 17.6689 15.7363 17.6689 15.0383C17.6689 14.3402 17.3916 13.6707 16.898 13.1771C16.4044 12.6835 15.735 12.4063 15.0369 12.4062C14.3389 12.4063 13.6694 12.6835 13.1758 13.1771C12.6822 13.6707 12.4049 14.3402 12.4049 15.0383Z"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path d="M13.2822 16.7925L16.7916 13.2832" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" />
    <path
      d="M8.89563 4.50977V8.89645L10.6503 10.6511"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export default Deactivate;
